import React from 'react';
import { InputField, colors } from '../../healtheraComponents';
import styled from 'styled-components';

type Props = {
  name: string;
  label: string;
  value: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string | null;
};

const InputColor = ({ name, label, value, placeholder='#2F9D6D', error, onChange, onBlur }: Props) => (
  <StyledInputField error={!!error} helperText={error} name={name} margintop="unset" placeholder={placeholder} $color={value} label={label} value={value} onChange={onChange} onBlur={onBlur} />
);

export const StyledInputField = styled(InputField)<{ $color?: string }>`
  && {
    position: relative;
  }
  && input,
  label {
    padding-left: 30px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 20px;
    left: 0;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid ${colors.GRAY};
    background-color: ${(props) => props.$color};
  }
`;

export default InputColor;
